import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { EditOutlined, TableOutlined } from '@ant-design/icons'
import { Button, Space, Tag } from 'antd'
import { PortalArticleTableItem } from '../../../../models/PortalArtigoModel'
import { portalEditorColors } from '../PortalEditorTheme'
import { PortalTableEditorModal } from './PortalTableEditorModal'

interface Props {
  value: PortalArticleTableItem
  autoEditToken?: number
  onAutoEditHandled?: () => void
  onChange: (table: PortalArticleTableItem) => void
}

export function PortalTableBlockEditor({
  value,
  autoEditToken,
  onAutoEditHandled,
  onChange,
}: Props) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (autoEditToken == null) return
    setOpen(true)
    onAutoEditHandled?.()
  }, [autoEditToken, onAutoEditHandled])

  return (
    <>
      <TableSummary>
        <SummaryIdentity>
          <TableIcon><TableOutlined /></TableIcon>
          <div>
            <strong>{value.name.trim() || 'Tabela sem nome'}</strong>
            <span>{value.columns.length} coluna(s) · {value.rows.length} linha(s)</span>
          </div>
        </SummaryIdentity>
        <Space wrap>
          <Tag color={value.export?.enabled === false ? 'default' : 'orange'}>
            Exportação {value.export?.enabled === false ? 'oculta' : 'visível'}
          </Tag>
          <Button icon={<EditOutlined />} onClick={() => setOpen(true)}>
            Editar tabela
          </Button>
        </Space>
      </TableSummary>
      <PortalTableEditorModal
        open={open}
        value={value}
        onCancel={() => setOpen(false)}
        onApply={(table) => {
          onChange(table)
          setOpen(false)
        }}
      />
    </>
  )
}

const TableSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 16px;
  border: 1px solid ${portalEditorColors.border};
  border-radius: 8px;
  background: ${portalEditorColors.hover};

  @media (max-width: 760px) {
    align-items: flex-start;
    flex-direction: column;
  }
`

const SummaryIdentity = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  div:last-of-type {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  span {
    color: ${portalEditorColors.muted};
    font-size: 12px;
  }
`

const TableIcon = styled.div`
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #fff1e9;
  color: ${portalEditorColors.orange};
  font-size: 20px;
`
